module.exports = __webpack_public_path__ + "a1b588627dd12c556a7e3cd81e400ecf.woff";